import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import './assets/icon/iconfont.css'
import 'vxe-table/lib/style.css'

import '../src/style/style.scss'
import '../src/style/_reset.scss'
import './assets/styles/base.scss'
import load from './common/loading/index'
import JalertModal from './common/Jalert/Jalert'
import V6ComponentUI from './components'
import 'xe-utils'
import showDialog from './util/showDialog.js'
import VXETable from 'vxe-table'
import { CdnResource } from './util/cdn';

Vue.prototype.$showDialog = showDialog

Vue.use(V6ComponentUI)
Vue.use(load)
Vue.use(JalertModal)
Vue.use(VXETable)

Vue.prototype.$XModal = VXETable.modal
Vue.prototype.$XPrint = VXETable.print
Vue.prototype.$XSaveFile = VXETable.saveFile
Vue.prototype.$XReadFile = VXETable.readFile
Vue.prototype.$cdn = CdnResource
ElementUI.Dialog.props.closeOnClickModal.default = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
